var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"elevation":"10","large":"","color":"#bb9af7","rounded":"","outlined":""},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-arrow-left ")]),_vm._v(" Back ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }